import createVueComponent from '../createVueComponent';

const ArrowUpLeft = createVueComponent('ArrowUpLeftIcon', [
  ['path', { d: 'M7 17V7h10', key: '11bw93' }],
  ['path', { d: 'M17 17 7 7', key: '2786uv' }],
]);

export default ArrowUpLeft;
